function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Moon"
}, /*#__PURE__*/React.createElement("title", null, "VF_moon_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M202 16.8c-18.3-6.5-38.7-9.7-60.2-9.7C63.5 7.1 0 49 0 141.7c0 92.7 63.5 134.6 141.7 134.6 21.5 0 42-3.2 60.2-9.7 48.2-17.2 81.5-57.7 81.5-124.9.1-67.2-33.3-107.7-81.4-124.9zM141.7 248c-33.9 0-62.2-8.9-81.7-25.7-21-18.1-31.7-45.2-31.7-80.6 0-35.4 10.6-62.5 31.7-80.6 19.5-16.8 47.8-25.7 81.7-25.7 8.2 0 16 .5 23.5 1.5-27.5 22-44.7 56.5-44.7 104.8s17.2 82.8 44.7 104.8c-7.5 1-15.3 1.5-23.5 1.5z"
}))));